// extracted by mini-css-extract-plugin
export default {"generalContainer":"Group_generalContainer__TIFXg","matchCardContainer":"Group_matchCardContainer__KyXp6","group":"Group_group__G9yp+"};